"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _basic_provider = _interopRequireWildcard(require("./_basic_provider"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class ImportFrom extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      url
    } = _ref;
    super({
      userTokenFactory
    });
    this.url = url;
  }
  async get() {
    const headers = await this.getHeaders();
    return _axios.default.get(this.url, headers);
  }
}
class LibraryCategories extends _basic_provider.default {
  async getAllCategories() {
    return await this._callApi({
      method: 'get',
      path: '/library-categories/import-export',
      errorName: 'LibraryCategoriesError'
    });
  }
  async setAllCategories(payload) {
    return await this._callApi({
      method: 'post',
      path: '/library-categories/import-export',
      payload,
      errorName: 'LibraryCategoriesError'
    });
  }
  async getCategories(categoryType) {
    return await this._callApi({
      method: 'get',
      path: '/library-categories',
      queryParams: {
        type: categoryType
      },
      errorData: {
        categoryType
      },
      errorName: 'LibraryCategoriesError'
    });
  }
  async getCategory(categoryType, id) {
    return await this._callApi({
      method: 'get',
      path: '/library-categories',
      queryParams: {
        type: categoryType,
        id
      },
      errorData: {
        categoryType,
        id
      },
      errorName: 'LibraryCategoriesError'
    });
  }
  async addCategory(categoryType, payload, id) {
    return await this._callApi({
      method: 'post',
      path: '/library-categories',
      queryParams: {
        type: categoryType,
        id
      },
      payload,
      errorData: {
        categoryType,
        id
      },
      errorName: 'LibraryCategoriesError'
    });
  }
  async editCategory(categoryType, payload, id) {
    return await this._callApi({
      method: 'put',
      path: '/library-categories',
      queryParams: {
        type: categoryType,
        id
      },
      payload,
      errorData: {
        categoryType,
        id
      },
      errorName: 'LibraryCategoriesError'
    });
  }
  async deleteCategory(categoryType, id) {
    return await this._callApi({
      method: 'delete',
      path: '/library-categories',
      queryParams: {
        type: categoryType,
        id
      },
      errorData: {
        categoryType,
        id
      },
      errorName: 'LibraryCategoriesError'
    });
  }
  async importAllCategories(url, token) {
    const importFrom = new ImportFrom({
      userTokenFactory: () => `USER ${token}`,
      url
    });
    try {
      const {
        data
      } = await importFrom.get();
      if (!data.allCategories) {
        throw new Error('URL is not "library-categories/import-export" provider');
      }
      await this.setAllCategories(data);
      return data;
    } catch (error) {
      throw new _basic_provider.ProviderError(error, {
        statusCode: _lodash.default.get(error, ['response', 'status']),
        url
      }, 'importAllCategories');
    }
  }
}
var _default = LibraryCategories;
exports.default = _default;